import type { Activity } from '../../../types'
import { createActivityTitle } from '../../helperFunctions/getActivityTitle'

const isHITL = (activity: Activity) => {
  const activityTitle = createActivityTitle(activity)
  return activityTitle.toLocaleLowerCase().includes('human help needed')
}

export { isHITL }
